import BigNumber from "bignumber.js"

export const getBalanceNumber = (balance, decimals = 18) => {
    const displayBalance = new BigNumber(balance).dividedBy(new BigNumber(10).pow(decimals))
    return displayBalance.toNumber()
}
  
export const getFullDisplayBalance = (balance, decimals = 18, point = 2) => {
    return new BigNumber(balance).dividedBy(new BigNumber(10).pow(decimals)).toFixed(point)
}